/**
 * Validate URL for safe use as an href attribute.
 * Only allows http and https schemes to prevent XSS via javascript: etc.
 */
export function isValidHttpUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
}
